import { ReadonlyURLSearchParams } from "next/navigation"

import { getCookieDomain, setCookie, SIGNUP_UTM_COOKIE_NAME } from "./"

export const setUtmCookie = (searchParams: ReadonlyURLSearchParams): void => {
  type utmKey = "utm_source" | "utm_campaign" | "utm_medium"

  const utmParams = {
    utm_source: "",
    utm_campaign: "",
    utm_medium: "",
  }

  Object.keys(utmParams).forEach((key) => {
    const value = searchParams.get(key)
    if (value) {
      utmParams[key as utmKey] = value
    }
  })

  setCookie({
    name: SIGNUP_UTM_COOKIE_NAME,
    value: JSON.stringify(utmParams),
    expiresInSeconds: 12 * 60 * 60,
    domain: getCookieDomain(process.env.NEXT_PUBLIC_VERCEL_ENV),
  })
}
